export default "__VITE_ASSET__e588b52d__"